import React from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";
import "./Info.scss";
import { CONTACT } from "../../../../config";

function Info() {
  return (
    <div className="contact-details">
      <div className="contact-details_row">
        <span className="contact-details_icon">
          <FaMapMarkerAlt />
        </span>
        <div className="contact-details_body">
          <h4>Location</h4>
          <p>{CONTACT.location}</p>
        </div>
      </div>

      <div className="contact-details_row contact-details_row--last">
        <span className="contact-details_icon">
          <FaEnvelope />
        </span>
        <div className="contact-details_body">
          <h4>Email</h4>
          <p>
            <Link
              className="email"
              onClick={() => (window.location = `mailto:${CONTACT.email}`)}
            >
              {CONTACT.email}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Info;
